import { searchUsersAddToGroup } from 'APP/model/search/searchModel';
import {
  GroupTypeAddUsersEnum,
  ISearchUsersAddToGroupRequest,
} from 'APP/model/search/searchModel.types';
import Entities from 'STORE';
import { User } from 'STORE/Users/User/User';

const LIMIT = 50;

export interface ISearchAddUsersToGroupParams
  extends Omit<ISearchUsersAddToGroupRequest, 'groupType' | 'groupId' | 'limit'> {
  groupId?: string;
  limit?: number;
}

export interface ISearchAddUsersToGroup {
  users: User[];
  hasMore: boolean;
  cursor?: string;
}

export async function searchAddUsersToGroup(
  params: ISearchAddUsersToGroupParams
): Promise<ISearchAddUsersToGroup> {
  const data: ISearchUsersAddToGroupRequest = {
    query: params.query,
    cursor: params.cursor ? params.cursor : undefined,
    limit: params.limit || LIMIT,
    offset: params.offset,
  };
  const group = params.groupId ? Entities.GroupsStore.getGroupById(params.groupId) : null;

  if (group) {
    data.groupId = group.id;
    data.groupType = group.isChannel
      ? GroupTypeAddUsersEnum.Public
      : GroupTypeAddUsersEnum.PrivateGroup;
  }

  try {
    const { users, hasMore, cursor } = await searchUsersAddToGroup(data);

    Entities.usersStore.add(users);

    return {
      users: users.map((user) => Entities.usersStore.getUserById(user.id)!),
      hasMore,
      cursor,
    };
  } catch {
    return {
      users: [],
      hasMore: false,
    };
  }
}
